export default __webpack_public_path__ + "static/media/alpineCropped.0d7bdb76.jpg";